import { handleRequest } from "../utilities/requestHandler";

export const getProductsByMachineId = (req_body) =>
    handleRequest("post", "/products/bymachineid", req_body);

export const normalizeMachineProductsResponse = (response) => {
    const payload = response?.data;
    if (Array.isArray(payload)) {
        return { products: payload, bom: [] };
    }
    if (payload && typeof payload === "object") {
        return {
            products: Array.isArray(payload.products) ? payload.products : [],
            bom: Array.isArray(payload.bom) ? payload.bom : [],
            bomTree: Array.isArray(payload.bomTree) ? payload.bomTree : [],
        };
    }
    return { products: [], bom: [], bomTree: [] };
};
